import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-opinator',
  templateUrl: './opinator.component.html',
  styleUrls: ['./opinator.component.scss']
})
export class OpinatorComponent {
  @Input() iframeUrl: SafeResourceUrl;

  constructor(
    private modalCtrl: ModalController
  ) {}

  onClose() {
    this.modalCtrl.dismiss();
  }
}
